module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-planning-8d40fd72eaeaf7d8d05ee7cb3b71a2b4.jpg";